var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.locationName)?_c('div',{staticClass:"calendar-item-location",class:{'calendar-item-location-url': _vm.hasUrl}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.locationName)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }